import { useLocalization } from "../egencia-provider/index.js";
import * as React from "react";
import { UitkField } from "../uitk-react-field/index.js";
import { UitkIcon, UitkIconSize } from "../uitk-react-icons/index.js";
import { classNames } from "../uitk-react-utils/index.js";
class Input extends React.Component {
  inputRef;
  static defaultProps = {
    hasClearButton: false,
    required: false,
    value: ""
  };
  autofillInput;
  constructor(props) {
    super(props);
    this.state = {
      autofilled: false,
      mounted: false
    };
    this.handleInputButtonClick = this.handleInputButtonClick.bind(this);
    this.setAutoFill = this.setAutoFill.bind(this);
    this.inputRef = props.domRef || React.createRef();
  }
  componentDidMount() {
    this.startTimer();
    this.setState({ mounted: true });
  }
  componentWillUnmount() {
    const { domRef } = this.props;
    if (domRef) {
      this.clearTimer();
    }
  }
  handleInputButtonClick(e) {
    e.stopPropagation();
    const {
      hasClearButton,
      handleClear,
      onChange,
      hasInputButton
    } = this.props;
    if (hasInputButton) {
      if (typeof hasInputButton.onClick === "function") {
        hasInputButton.onClick();
      }
    } else if (hasClearButton) {
      if (onChange) {
        onChange({
          target: { value: "" }
        });
      }
      if (typeof handleClear === "function") {
        handleClear();
      }
    }
    this.inputRef?.current?.focus();
  }
  setAutoFill() {
    const curr = this.inputRef?.current;
    if (curr) {
      try {
        if (curr.matches(":autofill")) {
          this.clearTimer();
          this.setState({ autofilled: true });
        }
      } catch (error) {
        try {
          if (curr.matches(":-webkit-autofill")) {
            this.clearTimer();
            this.setState({ autofilled: true });
          }
        } catch (error2) {
          return false;
        }
      }
    }
  }
  startTimer() {
    this.clearTimer();
    this.autofillInput = setTimeout(() => {
      this.setAutoFill();
    }, 500);
  }
  clearTimer() {
    clearTimeout(this.autofillInput);
  }
  render() {
    const {
      children,
      className,
      inputClassName,
      style,
      label,
      hasBorder,
      hasFloatedLabel,
      hasVisibleLabel,
      icon,
      instruction,
      invalid,
      l10n,
      hasClearButton,
      required,
      domRef,
      placeholder,
      hasInputButton,
      handleClear,
      ...attributes
    } = this.props;
    const { id, disabled, readOnly, value } = attributes;
    const { autofilled, mounted } = this.state;
    const showClearButton = hasClearButton && value;
    const fieldProps = {
      disabled,
      hasAutofill: autofilled,
      hasBorder,
      hasFloatedLabel,
      hasVisibleLabel,
      icon,
      id,
      instruction,
      invalid,
      label,
      placeholder,
      readOnly,
      required,
      className,
      style
    };
    const inputExtraAttr = attributes;
    const computedInputClassName = classNames("uitk-field-input", inputClassName, showClearButton && "has-input-cta");
    let ariaFieldLabel = label;
    if (React.isValidElement(label)) {
      const labelProp = label.props;
      ariaFieldLabel = labelProp && labelProp.children && labelProp.children[0];
    }
    const localizedClearIconLabel = l10n.formatText("clear");
    const clearIconTitle = [localizedClearIconLabel, ariaFieldLabel].join(" ");
    const localizedInputButtonLabel = hasInputButton?.label ?? l10n.formatText("send");
    const inputButtonIconName = hasInputButton?.iconName ?? "send";
    return /* @__PURE__ */ React.createElement(UitkField, { ...fieldProps }, /* @__PURE__ */ React.createElement(
      "input",
      {
        ...inputExtraAttr,
        className: computedInputClassName,
        "aria-describedby": invalid ? `${id}-error` : void 0,
        placeholder,
        ref: this.inputRef,
        id,
        "aria-required": required,
        "aria-invalid": !!invalid
      }
    ), children, mounted && hasInputButton ? /* @__PURE__ */ React.createElement("button", { className: "uitk-input-button uitk-input-cta", "aria-label": localizedInputButtonLabel, onClick: this.handleInputButtonClick }, /* @__PURE__ */ React.createElement(UitkIcon, { name: inputButtonIconName, size: UitkIconSize.SMALL, id: `${id}-input-button` })) : mounted && showClearButton && /* @__PURE__ */ React.createElement("button", { className: "uitk-clear-button uitk-input-cta", onClick: this.handleInputButtonClick }, /* @__PURE__ */ React.createElement(UitkIcon, { name: "cancel", size: UitkIconSize.SMALL, title: clearIconTitle, id: `${id}-clear-input-button` })));
  }
}
export const UitkInput = (props) => {
  const l10n = useLocalization();
  return /* @__PURE__ */ React.createElement(Input, { l10n, ...props });
};
